import { render, staticRenderFns } from "./FormInputDatalist.vue?vue&type=template&id=352e0aed&"
import script from "./FormInputDatalist.vue?vue&type=script&lang=js&"
export * from "./FormInputDatalist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports